<style lang="scss">
  @use "../../../../assets/css/global.scss" as *;
  @use "../../../../assets/css/_colors.scss" as *;
  .task-group {
    text-align: left;
    display: grid;
    gap: 0.2rem;
    padding: 1.2rem;
    border-radius: 0.5rem;
    border: 2px solid $light-gray;
    background-color: #fff;
    opacity: 0.5;
    transition: 0.3s ease;

    &.selected {
      box-shadow: $subtle-shadow;
      opacity: 1;
    }

    &.deselected {
      opacity: 0.7;
    }

    &:hover.deselected {
      cursor: pointer;
      border: 2px solid $blue;
    }

    .icon-check-wrapper {
      display: flex;
      justify-content: space-between;
      margin-bottom: 0.5rem;

      .check-icon {
        font-size: 1.5rem;

        &.completed {
          color: $turquoise;
        }

        &.deselected {
          color: $gray;
        }

        &.selected {
          color: $turquoise;
        }
      }
    }

    h2 {
      font-size: 1.2rem;
      color: $text-black;
    }

    p,
    b {
      font-size: 0.9rem;
    }

    .subtitle {
      color: $text-gray;
      font-size: 0.9rem;
      margin-bottom: 2rem;
    }

    .progress-text {
      color: $text-gray;
    }

    .progress-wrapper {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 1.5rem;
      align-items: center;

      .progress-bar {
        height: 0.4rem;
        background-color: $light-green;
        border-radius: 0.5rem;

        .progress-fill {
          height: 100%;
          background-color: $turquoise;
          border-radius: 0.5rem;
        }
      }

      .arrow {
        padding: 0rem 0.5rem;
        font-size: 1.2rem;
        color: $black-text;
      }
    }
  }
</style>

<script>
  export let taskGroup;
  import TrainingHubIcon from "./Components/TrainingHubIcon.svelte";
  import { interactiveTasks } from "./stores";

  $: s = taskGroup.duration === 1 ? "s" : "";
  $: subtitleText = taskGroup.duration
    ? `About ${taskGroup.duration} min${s}`
    : `Completed`;
  $: selected = $interactiveTasks.selectedTaskGroupId === taskGroup.taskGroupId;
  $: deselected = !selected;
  $: width = taskGroup.totalTasks
    ? (taskGroup.completedTasks / taskGroup.totalTasks) * 100
    : 0;

  $: optional = taskGroup.optional ? " (Optional)" : "";
</script>

<button
  class="task-group"
  class:selected
  class:deselected
  on:click={() => interactiveTasks.setTaskGroup(taskGroup.taskGroupId)}
>
  <div class="icon-check-wrapper">
    <TrainingHubIcon icon="fa-regular {taskGroup.icon}" size="large" />
    {#if taskGroup.completedTasks === taskGroup.totalTasks}
      <i class="check-icon fa-solid fa-circle-check completed"></i>
    {:else}
      <i class="check-icon fa-regular fa-circle" class:selected class:deselected
      ></i>
    {/if}
  </div>
  <h2>{taskGroup.cardTitle}</h2>
  <p class="subtitle">{subtitleText}</p>
  <b class="progress-text"
    >{taskGroup.completedTasks}/{taskGroup.totalTasks} tasks{optional}</b
  >
  <div class="progress-wrapper">
    <div class="progress-bar">
      <div class="progress-fill" style="width: {width}%"></div>
    </div>
    <i class="arrow fa-regular fa-chevron-right"></i>
  </div>
</button>
